export function startOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function endOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
}

export function fmtMonth(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

export function fmtMonthKo(date: Date): string {
  return `${date.getFullYear()}년 ${date.getMonth() + 1}월`;
}

export function parseMonth(value: string): Date {
  const [y = 0, m = 1] = value.split('-').map(Number);
  return new Date(y, m - 1, 1);
}

export function fmtPercent(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`;
}

export function fmtRate(rate: number): string {
  return `${(rate * 100).toFixed(2)}%`;
}

export function fmtDate(iso: string): string {
  if (!iso) return '-';
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate(),
  ).padStart(2, '0')}`;
}

export function fmtPeriod(fromIso: string, toIso: string): string {
  const f = new Date(fromIso);
  const t = new Date(toIso);
  return `${f.getMonth() + 1}/${f.getDate()} ~ ${t.getMonth() + 1}/${t.getDate()}`;
}
